import actionTypes from '../actions/types';

const JPUSHDATA_LIMIT = 20;

export const INITIAL_STATE = {
  JPushLists: [],
};

export const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.SET_JPUSH_DATA: {
      const newJPushLists = action.data.concat(state.JPushLists);
      if (newJPushLists.length > JPUSHDATA_LIMIT) newJPushLists.length = JPUSHDATA_LIMIT;
      return { ...state, JPushLists: newJPushLists };
    }
    case actionTypes.CLEAR_JPUSH_DATA:
      return { ...state, JPushLists: [] };
    default:
      return state;
  }
};
